// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `table.dataTable tbody tr.selected {
    color: white;
    background-color: grey !important;
    box-shadow: none;
}

table.dataTable tbody tr:hover {
    background-color: var(--primary-color) !important;
    box-shadow: none;
}

.dataTables_wrapper {
    /*display:flex;
    flex-direction:column;
    flex: 1 1 auto;*/
    height: 100%;
}

.dataTables_scroll {
    display: flex;
    flex-direction: column;
    flex: 1 1 auto;
    height: 100%;
}

.dataTables_scrollBody {
    flex: 1 1 auto;
}

.dataTables_scrollHead {
    min-height: 40px;
}

.dataTables_info {
    display: none;
}

.dataTables_paginate {
    display: none;
}

.dataTables_filter {
    display: none;
}

.tfoot {
    display: table-header-group;
}

.tableHeight {
    min-height: 500px;
}


.grid {
    display: grid;
    grid: auto-flow / 1fr 1fr 1fr 1fr;
    grid-gap: 10px;
    grid-auto-rows: minmax(100px, auto);
}

.one {
    grid-column: 1;
    grid-row: 1;
    padding: 15px;
}

.two {
    grid-column: 1;
    grid-row: 2;
    min-height: 500px;
    grid-column: span 4;
    padding: 15px;
}

.threeFirstHalf {
    grid-column: 1;
    grid-row: 3;
    padding: 15px;
    grid-column: span 2;
    min-height: 400px;
}

.threeSecondHalf {
    grid-column: 3;
    grid-row: 3;
    padding: 15px;
    grid-column: span 2;
    min-height: 400px;
}

.four {
    grid-column: 1;
    grid-row: 4;
    padding: 15px;
    grid-column: span 4;
    min-height: 400px;
}



.five {
    grid-column: 3;
    grid-row: 5;
    padding: 15px;
    grid-column: span 4;
}

.fiveFullRow {
    grid-column: 1;
    grid-row: 5;
    padding: 15px;
    grid-column: span 4;
}

.six {
    grid-column: 1;
    grid-row: 6;
    padding: 15px;
    grid-column: span 4;
    min-height: 400px;
}

.seven {
    grid-column: 1;
    grid-row: 7;
    padding: 15px;
    grid-column: span 4;
}

.example-error {
    color: red;
}


`, "",{"version":3,"sources":["webpack://./src/app/settings/logsettings/logs.settings.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,iCAAiC;IACjC,gBAAgB;AACpB;;AAEA;IACI,iDAAiD;IACjD,gBAAgB;AACpB;;AAEA;IACI;;oBAEgB;IAChB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,cAAc;IACd,YAAY;AAChB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,iBAAiB;AACrB;;;AAGA;IACI,aAAa;IACb,iCAAiC;IACjC,cAAc;IACd,mCAAmC;AACvC;;AAEA;IACI,cAAc;IACd,WAAW;IACX,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,iBAAiB;IACjB,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,iBAAiB;AACrB;;;;AAIA;IACI,cAAc;IACd,WAAW;IACX,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,UAAU;AACd","sourcesContent":["table.dataTable tbody tr.selected {\n    color: white;\n    background-color: grey !important;\n    box-shadow: none;\n}\n\ntable.dataTable tbody tr:hover {\n    background-color: var(--primary-color) !important;\n    box-shadow: none;\n}\n\n.dataTables_wrapper {\n    /*display:flex;\n    flex-direction:column;\n    flex: 1 1 auto;*/\n    height: 100%;\n}\n\n.dataTables_scroll {\n    display: flex;\n    flex-direction: column;\n    flex: 1 1 auto;\n    height: 100%;\n}\n\n.dataTables_scrollBody {\n    flex: 1 1 auto;\n}\n\n.dataTables_scrollHead {\n    min-height: 40px;\n}\n\n.dataTables_info {\n    display: none;\n}\n\n.dataTables_paginate {\n    display: none;\n}\n\n.dataTables_filter {\n    display: none;\n}\n\n.tfoot {\n    display: table-header-group;\n}\n\n.tableHeight {\n    min-height: 500px;\n}\n\n\n.grid {\n    display: grid;\n    grid: auto-flow / 1fr 1fr 1fr 1fr;\n    grid-gap: 10px;\n    grid-auto-rows: minmax(100px, auto);\n}\n\n.one {\n    grid-column: 1;\n    grid-row: 1;\n    padding: 15px;\n}\n\n.two {\n    grid-column: 1;\n    grid-row: 2;\n    min-height: 500px;\n    grid-column: span 4;\n    padding: 15px;\n}\n\n.threeFirstHalf {\n    grid-column: 1;\n    grid-row: 3;\n    padding: 15px;\n    grid-column: span 2;\n    min-height: 400px;\n}\n\n.threeSecondHalf {\n    grid-column: 3;\n    grid-row: 3;\n    padding: 15px;\n    grid-column: span 2;\n    min-height: 400px;\n}\n\n.four {\n    grid-column: 1;\n    grid-row: 4;\n    padding: 15px;\n    grid-column: span 4;\n    min-height: 400px;\n}\n\n\n\n.five {\n    grid-column: 3;\n    grid-row: 5;\n    padding: 15px;\n    grid-column: span 4;\n}\n\n.fiveFullRow {\n    grid-column: 1;\n    grid-row: 5;\n    padding: 15px;\n    grid-column: span 4;\n}\n\n.six {\n    grid-column: 1;\n    grid-row: 6;\n    padding: 15px;\n    grid-column: span 4;\n    min-height: 400px;\n}\n\n.seven {\n    grid-column: 1;\n    grid-row: 7;\n    padding: 15px;\n    grid-column: span 4;\n}\n\n.example-error {\n    color: red;\n}\n\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
